import { render, staticRenderFns } from "./MapBelgium.vue?vue&type=template&id=391dbb92"
import script from "./MapBelgium.vue?vue&type=script&lang=js"
export * from "./MapBelgium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports